   <p-card>
      <div class="grid">
         <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
            <div class="p-0 border-round-sm font-bold">
                              <button type="button" class="fa fa-question helpicon"(click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','16')" pTooltip="Help" tooltipPosition="bottom"></button>

            </div>

         </div>
      </div>
      <form  [formGroup]="uamfrom" >
         <div class="grid">
            <div class="col-6">
             <label class="required-label" for="user">User<span>*</span></label>
               <p-dropdown [filter]="true" [resetFilterOnHide]="true"  [options]="userlist"
                placeholder="Select User" optionLabel="fullname" optionValue="userid" styleClass="fixed-width-dropdown-filter" 
                 inputId="user" name="user" appendTo="body" formControlName="user" (onChange)="onSelectFromUser(uamfrom.get('user').value)" ></p-dropdown>
                    <span class="errormessage" *ngIf="uamfrom.get('user').invalid && uamfrom.get('user').touched">
                    {{ getErrorMessage(uamfrom, validation_message, 'user') }}
                </span>
            </div>
            <div class="col-6">
             <label for="product" class="required-label">Product <span>*</span></label>
             <p-dropdown [options]="productList" [filter]="true" inputId="product" name="product" 
                optionLabel="productname" optionValue="productid"   appendTo="body" placeholder="Select Product"
                [filter]="true" [resetFilterOnHide]="true"
                formControlName="product" (onChange)="getUAMdetails(uamfrom.get('user').value,uamfrom.get('product').value)"></p-dropdown>
                  <span class="errormessage" *ngIf="uamfrom.get('product').invalid && uamfrom.get('product').touched">
                    {{ getErrorMessage(uamfrom, validation_message, 'product')}}
                </span>
            </div>
         </div>
         <div *ngIf="this.uamfrom.get('product').value!=='' && this.uamfrom.get('product').value!==null">
          <div class="formgrid grid" >
              <div class="field col-12 md:col-6 lg:col-6 sm:col-12" *ngIf="configParams.orgtype=='P'"  >
              <label for="group" class="required-label">Client Group</label>
              <p-multiSelect [options]="grouplist"  name="group" id="group" inputId="groupid"
                 optionLabel="groupname"  appendTo="body" placeholder="Select Group"
                 formControlName="group" (onChange)="getentitylist()"[filter]="true" [resetFilterOnHide]="true"[showClear]="true"></p-multiSelect>
             </div>
          <!-- </div> -->
          <!-- <div class="formgrid grid"  style="background-color: aqua;"> -->
             <div class="field col-12 md:col-6 lg:col-6 sm:col-12" >
              <label for="entity" class="required-label">Entity</label>
              <p-multiSelect [options]="entitylist"  name="entity" inputId="companyid" id="entity"
                 optionLabel="companyname"  appendTo="body" placeholder="Select Entity"
                 formControlName="entity" [filter]="true" [resetFilterOnHide]="true" [showClear]="true"></p-multiSelect>
             </div>
          <!-- </div> -->
        
         <!-- <div class="formgrid grid" style="background-color: yellow;" > -->
           <div class="field col-12 md:col-6 lg:col-6 sm:col-12" *ngIf="configParams?.requirevertlabel=='Y'">
            <label class="required-label" for="vertical" >Vertical</label>
              <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Vertical" [options]="verticallist"
               placeholder="Select Vertical"
                optionLabel="name" 
                name="vertical" inputId="vertical" appendTo="body" formControlName="vertical" (onChange)="getsubVerticallist()" ></p-multiSelect>
           </div>
       
        <!-- </div> -->
        <!-- <div class="formgrid grid" *ngIf="configParams?.requiresubvertlabel=='Y'"> -->
             <div class="field col-12 md:col-6 lg:col-6 sm:col-12" *ngIf="configParams?.requiresubvertlabel=='Y'" >
            <label for="subvertical" class="required-label">Sub-Vertical </label>
            <p-multiSelect [options]="subverticallist"  name="subvertical" id="subvertical"
               optionLabel="subverticalname" inputId="subverticalid" appendTo="body" placeholder="Select Sub Vertical"
               formControlName="subvertical" [filter]="true" [resetFilterOnHide]="true" [showClear]="true" ></p-multiSelect>
           </div>
        <!-- </div> -->
        <!-- <div class="grid"> -->
           <div class="field col-12 md:col-6 lg:col-6 sm:col-12">
            <label class="required-label" for="department">Department</label>
              <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Department" [options]="deplist"
               placeholder="Select Department"
                optionLabel="departmentname" inputId="departmentid" styleClass="fixed-width-dropdown-filter" 
                name="department"  appendTo="body" formControlName="department" (onChange)="getsubdeplist()" ></p-multiSelect>
           </div>
           <div class="field col-12 md:col-6 lg:col-6 sm:col-12" *ngIf="configParams?.requiresubdeptlabel=='Y'" >
            <label for="subdepartment" class="required-label">Sub Department</label>
            <p-multiSelect [options]="subdeplist"  inputId="subdepartmentid" name="subdepartment"
               optionLabel="subdepartmentname"  appendTo="body" placeholder="Select Sub Department"
               formControlName="subdepartment" [filter]="true" [resetFilterOnHide]="true" [showClear]="true"></p-multiSelect>
           </div>
        </div>
<p-accordion [activeIndex]="0">
   <p-accordionTab  header="Location Specific Mapping">
      <div class="grid">
         <div class="col-4" *ngIf="configParams.iscountry=='Y'">
          <label class="required-label"  for="country">Country</label>
            <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Country" [options]="countrylist"
             placeholder="Select Country"optionLabel="countryname" styleClass="fixed-width-dropdown-filter" 
              inputId="countryid" name="country" appendTo="body"  formControlName="country" (onChange)="getstatelist()" ></p-multiSelect>
         </div>
         <div class="col-4">
          <label for="state" class="required-label">State</label>
          <p-multiSelect [filter]="true" [resetFilterOnHide]="true" [showClear]="true" pTooltip="Select State" 
          [options]="statelist" placeholder="Select State"
           optionLabel="statename" styleClass="fixed-width-dropdown-filter" 
           name="state" inputId="stateid"appendTo="body"  formControlName="state" (onChange)="gethublist()"></p-multiSelect>
         </div>
         <div class="col-4" *ngIf="configParams.ishub=='Y'">
            <label for="hub" class="required-label">Hub </label>
            <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Hub" [options]="hublist"
            placeholder="Select Hub" optionLabel="hubname" styleClass="fixed-width-dropdown-filter" 
             name="hub" inputId="hubid"appendTo="body" formControlName="hub" (onChange)="getRegionlist()"></p-multiSelect>
           </div>
      </div>
      <div class="grid">
         <div class="col-4" *ngIf="configParams.isregion=='Y'">
            <label for="region" class="required-label">Region </label>
            <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Region"
             [options]="regionlist" placeholder="Select Region"
             optionLabel="regionname"  styleClass="fixed-width-dropdown-filter" 
             name="region" inputId="regionid" appendTo="body"  formControlName="region" (onChange)="getcitylist()"></p-multiSelect>
           </div>
           <div class="col-4" *ngIf="configParams.iscity=='Y'">
            <label for="cityid" class="required-label">City </label>
            <p-multiSelect [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select City" [options]="citylist"
             placeholder="Select City" optionLabel="cityname" inputId="cityid" 
             name="cityid"  appendTo="body" formControlName="cityid" (onChange)="getlocationlist()" ></p-multiSelect>
           </div>
           <div class="col-4">
            <label for="location" class="required-label">Location </label>
            <p-multiSelect [filter]="true" [resetFilterOnHide]="true" [showClear]="true" pTooltip="Select Location" [options]="locationlist"
            placeholder="Select Location"
             optionLabel="locationname"  styleClass="fixed-width-dropdown-filter" 
             name="location" inputId="locationid" appendTo="body"  formControlName="location"></p-multiSelect>
           </div>
      </div>
      <div class="grid" *ngIf="this.uamfrom.get('product').value==2  || this.uamfrom.get('product').value==4">
           <div class="col-4" >
            <label for="specialviewright" class="required-label">Special View Right </label>
            <p-dropdown [filter]="true" [resetFilterOnHide]="true" [showClear]="true" pTooltip="Select Special View Right" [options]="specialviewrightlist"
            placeholder="Select Special View Right"
             optionLabel="labelname"  optionValue="value" styleClass="fixed-width-dropdown-filter" 
             name="specialviewright" id="locationid" appendTo="body"  formControlName="specialviewright"></p-dropdown>
           </div>
      </div>
   </p-accordionTab>
</p-accordion>
   
 <p-accordion [activeIndex]="0">
   <p-accordionTab header="Module Specific Mapping" >
      <div class="customepcontent"> 
  <div class="grid" *ngIf="this.uamfrom.get('product').value==9  || this.uamfrom.get('product').value==8 || this.uamfrom.get('product').value==13"> 
   <div class="col-6" *ngIf="this.uamfrom.get('product').value==8 || this.uamfrom.get('product').value==13">
      <label for="process" class="required-label">Process</label>
      <p-multiSelect [options]="processlist"  name="process"  inputId="value" 
         optionLabel="labelname"  appendTo="body"  placeholder="Select Process"
         formControlName="fld1" [filter]="true" [resetFilterOnHide]="true" [showClear]="true"></p-multiSelect>
     </div>
     <div class="col-6" *ngIf="this.uamfrom.get('product').value==9 ">
      <label for="casetype" class="required-label">Case Type</label>
      <p-multiSelect [options]="casetypelist"  name="casetype" id="casetype"  inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Case type"[filter]="true" [resetFilterOnHide]="true"[showClear]="true"
         formControlName="fld1"  ></p-multiSelect>
     </div>
</div>
<div class="grid">
   <div class="col-6" *ngIf="this.uamfrom.get('product').value==2">
      <label for="contractcat" class="required-label">Contract Category</label>
      <p-multiSelect [options]="contcatelist"  name="contractcat" id="contractcat"  inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Contract Category"[filter]="true" [resetFilterOnHide]="true"[showClear]="true"
         formControlName="fld1" ></p-multiSelect>
     </div>
     <div class="col-6" *ngIf="this.uamfrom.get('product').value==3">
      <label for="category" class="required-label">Category</label>
      <p-multiSelect [options]="assementcategorylist"  name="category" id="category" inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Category"[filter]="true" [resetFilterOnHide]="true"[showClear]="true"
         formControlName="fld1"  ></p-multiSelect>
     </div>
      <div class="col-6" *ngIf="this.uamfrom.get('product').value==16">
      <label for="category" class="required-label">Category</label>
      <p-multiSelect [options]="assignemntcategroy"  name="category" id="category"  inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Category"[filter]="true" [resetFilterOnHide]="true" [showClear]="true"
         formControlName="fld1"></p-multiSelect>
     </div>
</div>

<div class="grid" *ngIf="this.uamfrom.get('product').value==4 || this.uamfrom.get('product').value==5">

<div class="col-6" *ngIf="this.uamfrom.get('product').value==4">
      <label for="regiscat" class="required-label">Registration Category</label>
      <p-multiSelect [options]="regcatelist"  name="regiscat" id="regiscat"
       inputId="value" [filter]="true" [resetFilterOnHide]="true"
         optionLabel="labelname"  appendTo="body" placeholder="Select Registration Category"[showClear]="true"
         formControlName="fld1"   ></p-multiSelect>
     </div>
     <div class="col-6" *ngIf="this.uamfrom.get('product').value==5">
      <label for="doccat" class="required-label">Document Category</label>
      <p-multiSelect [options]="doccatelist"  name="doccat" id="doccat" inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Document Category"
         [filter]="true" [resetFilterOnHide]="true"[showClear]="true"
         formControlName="fld1"  ></p-multiSelect>
     </div>
</div>
<div class="grid" >
<div class="col-6" *ngIf="this.uamfrom.get('product').value==11">
      <label for="policytype" class="required-label">Policy Type</label>
      <p-multiSelect [options]="policytypelist"  name="policytype"id="policytype"  inputId="value" 
         optionLabel="labelname"  appendTo="body" [filter]="true" [resetFilterOnHide]="true"placeholder="Select Policy Type"
         formControlName="fld1"  [showClear]="true"></p-multiSelect>
     </div>
       <div class="col-6" *ngIf="this.uamfrom.get('product').value==1">
      <label for="lawcat" class="required-label">Law Category</label>
      <p-multiSelect [options]="lawcatlist"  name="lawcat"  id="lawcat" inputId="value" 
         optionLabel="labelname"  appendTo="body" placeholder="Select Law category"[filter]="true" [resetFilterOnHide]="true"[showClear]="true"
         formControlName="fld1"  ></p-multiSelect>
     </div>
</div>
      </div>
 
   </p-accordionTab>
 </p-accordion>
  </div>
      </form>

            <div class="textaligncenter mappingfooter" *ngIf="this.uamfrom.get('product').value!=='' && this.uamfrom.get('product').value!==null">
   <p-button class="m-1" label="Save" pTooltip="Save" tooltipPosition="bottom" styleClass="customesave margintopmapping" (click)="saveuam()" ></p-button>  
   <p-button class="m-1 " label="Delete Mapping" styleClass="customeclose margintopmapping"  pTooltip="Delete Mapping" tooltipPosition="bottom"  (click)="deletemapping()"></p-button>
   <!-- <button pButton type="button" icon="pi pi-refresh" (click)="refresh()"  ></button> -->
                  <i class="fa fa-refresh refreshbuttonmappig margintopmapping" aria-hidden="true" (click)="refresh()" pTooltip="Reset" tooltipPosition="bottom" ></i>


 </div>
   </p-card>
 
